import { createTheme } from '@mui/material/styles';

const GlobalStyles = createTheme({
  typography: {
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 700
  },
  palette: {
    primary: {
      // main: '#002C3E',
      main: '#00205D',
      contrastText: '#fff'
    },
    secondary: {
      main: '#3b65e3',
      contrastText: '#fff'
    },
    lighrError: {
      main: '#F7444E',
      contrastText: '#000'
    },
    lignhtwarning: {
      main: '#f7cb73',
      contrastText: '#2f2b3d'
    },
    success: {
      main: '#008000',
      contrastText: '#fff'
    },
    draft: {
      main: '#808080',
      contrastText: '#fff'
    },
    paid: {
      main: '#28a745',
      contrastText: '#ffffff'
    },
    failed: {
      main: '#dc3545',
      contrastText: '#ffffff'
    },
    canceled: {
      main: '#6c757d',
      contrastText: '#fff'
    },
    feedback: {
      main: '#6f42c1',
      contrastText: '#fff'
    },
    pending: {
      main: '#ffc107',
      contrastText: '#000000'
    },
    verify: {
      main: '#007bff',
      contrastText: '#ffffff'
    },
    partialpayment: {
      main: '#20c997',
      contrastText: '#ffffff'
    },
    overdue: {
      main: '#fd7e14',
      contrastText: '#ffffff'
    },
    writeoff: {
      main: '#343a40',
      contrastText: '#ffffff'
    },
    manual: {
      main: '#6f42c1',
      contrastText: '#fff'
    },
    fullpayment: {
      main: '#6f42c1',
      contrastText: '#fff'
    },
    automatic: {
      main: '#007bff',
      contrastText: '#ffffff'
    },
    scheduled: {
      main: '#00ACC1',
      contrastText: '#ffffff'
    }
    //   // contrastText: {
    //   //   main: "#2f2b3d",
    //   // },
    //   // blue: {
    //   //   main: "#78bbc3",
    //   // },
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          '&.MuiButton-sizeLarge': {
            padding: '11px 20px',
            minWidth: '350px',
            fontSize: '16px'
          },
          // Some CSS
          '&.MuiButton-sizeSmall': {
            minWidth: '150px',
            padding: '5px 15px',
            fontWeight: 700
          },

          '&.MuiButton-sizeMedium': {
            minWidth: '200px',
            padding: '10px 20px',
            fontSize: '16px',
            lineHeight: '20px',
            fontWeight: 700
          },

          boxShadow: 'none',
          fontWeight: '700',
          borderRadius: '5px',
          textTransform: 'none'
          // color: "#fff",
        },
        containedPrimary: {
          // background: "#df7a5e",
          '& i.icon-plus': {
            fontSize: '15px',
            fontWeight: 700
          },
          '&:hover': {
            // backgroundColor: "#fff",
            // border:"1px solid #df7a5e",
            // outline: "2px solid #df7a5e",
            // color: "#df7a5e",
            // boxShadow: "none",
          }
        },
        containedSecondary: {
          // background: "#3c405b",
          // border: "1px solid #3c405b",
          // color: "#fff",
          '&:hover': {
            // backgroundColor: "#fff",
            // border: "1px solid #3c405b",
            // color: "#3c405b",
            // boxShadow: "none",
          }
        },

        containedInfo: {
          // background: "#f4f1de",
          // border: "1px solid #f4f1de",
          // color: "#000000",

          '&.cancel__btn': {
            borderRadius: '5px',
            backgroundColor: '#f6f6f7',
            border: '1px solid rgba(142,142,147,0.3)',
            color: '#2f2b3d',
            opacity: 0.8
          },
          '&:hover': {
            // backgroundColor: "#fff",
            // border: "1px solid #f4f1de",
            // color: "#000000",
            // boxShadow: "none",
          }
        }
      }
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.actionBtn': {
            boxShadow: 'none',
            borderRadius: '5px',
            padding: '5px',
            textTransform: 'none',
            background: 'rgba(0, 0, 0, 0.06)',
            border: '1px solid rgba(0, 0, 0, 0.15)',
            '&:not(.MuiIconButton-colorPrimary)': {
              '& .MuiSvgIcon-root': {
                color: 'rgba(0, 0, 0, 0.54)',
                '&:hover': {
                  color: '#00205D'
                }
              }
            },
            '&:hover': {
              backgroundColor: '#fff',
              border: '1px solid rgba(0, 0, 0, 0.15)',
              color: '#00205D'
              // boxShadow: "none",
            }
          }
        },
        colorSecondary: {
          '&.iconAddRemove': {
            padding: '0px',
            width: '24px',
            height: '24px',
            background: '#2f2b3d',
            border: '1px solid #2f2b3d',
            '& .MuiSvgIcon-root': {
              fontSize: '22px',
              color: '#fff'
            },
            '&:hover': {
              backgroundColor: '#fff',
              border: '1px solid #2f2b3d',
              color: '#df7a5e',
              boxShadow: 'none',
              '& .MuiSvgIcon-root': {
                color: '#2f2b3d'
              }
            }
          }
        }
      }
    },

    MuiChip: {
      styleOverrides: {
        // Name of the slot
        root: {
          borderRadius: '5px',
          minWidth: '95px',
          padding: '4px',
          width: 'auto',
          height: 'auto',
          '.MuiChip-label': {
            fontSize: '13px',
            fontWeight: '700',
            letterSpacing: '0.5px',
            opacity: 1
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        // Name of the slot
        root: {
          '.MuiTableHead-root': {
            '.MuiTableRow-head': {
              '.MuiTableCell-head': {
                fontSize: '13px',
                fontWeight: '700',
                color: '#555',
                padding: '12px 20px'
              }
            }
          },
          '.MuiTableRow-root': {
            '.MuiTableCell-root': {
              fontSize: '13px',
              fontWeight: '700',
              padding: '12px 20px'
            }
          }
        }
      }
    },

    MuiModal: {
      styleOverrides: {
        // Name of the slot
        root: {
          '> .MuiBox-root': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 600,
            width: '100%',
            background: '#fff',
            border: 'none',
            borderRadius: '3px',
            padding: 0,
            '&.largeModal': {
              maxWidth: '1100px',
              '.MuiCard-root': {
                '.MuiCardContent-root': {
                  padding: '30px 20px',
                  maxWidth: '100%'
                }
              }
            },
            '.MuiCard-root': {
              '.MuiCardHeader-root ': {
                backgroundColor: '#f7f8f3',
                textAlign: 'center',
                padding: '16px',
                '.MuiCardHeader-action': {
                  position: 'absolute',
                  zIndex: 98,
                  top: '-20px',
                  right: '-10px',
                  '.MuiButtonBase-root': {
                    borderRadius: '8px',
                    boxShadow: '0px 5px 40px 0px rgba(0, 1, 1, 0.15)',
                    background: '#fff',
                    padding: '15px'
                  }
                },
                '.MuiTypography-root': {
                  fontSize: '20px',
                  lineHeight: '25px',
                  color: '#2f2b3d',
                  fontWeight: 700
                }
              },
              '.MuiCardContent-root': {
                maxWidth: '400px',
                margin: '0 auto',
                padding: '30px 0 20px',
                'h3.MuiTypography-root': {
                  textAlign: 'center',
                  opacity: 0.8,
                  fontSize: '20px',
                  lineHeight: '30px',
                  color: '#2f2b3d',
                  fontWeight: 700,
                  margin: '30px 0 10px'
                }
              },
              '.MuiCardActions-root': {
                padding: '20px 0 40px'
              }
            }
          },
          '&.cmn__delete__modal': {
            '.MuiBox-root': {
              '.MuiCard-root': {
                '.MuiCardActions-root': {
                  padding: '20px 0 60px'
                }
              }
            }
          },
          '&.MuiDrawer-modal': {
            '&.previewModal': {
              '.MuiDrawer-paper': {
                minWidth: '100%',
                maxWidth: '100%',
                top: '0px',
                right: '0px',
                overflow: 'visible'
              }
            },
            '.MuiDrawer-paper': {
              minWidth: '600px',
              maxWidth: '600px',
              top: '0px',
              right: '0px',
              overflow: 'visible',
              '.MuiBox-root': {
                // Styles specific to MuiDrawer-modal
                position: 'relative',
                top: 0,
                bottom: 0,
                left: 0,
                transform: 'none',
                maxWidth: 'none',
                '.MuiCard-root': {
                  boxShadow: 'none',
                  '.MuiCardHeader-root ': {
                    backgroundColor: '#f7f8f3',
                    textAlign: 'center',
                    padding: '16px',
                    '.MuiCardHeader-action': {
                      position: 'relative',
                      top: '0px',
                      right: '10px',
                      '.MuiButtonBase-root': {
                        borderRadius: '8px',
                        boxShadow: '0px 5px 40px 0px rgba(0, 1, 1, 0.15)',
                        background: '#fff',
                        padding: '5px'
                      }
                    }
                  },
                  '.MuiCardContent-root': {
                    maxWidth: 'none',
                    margin: '0 auto',
                    padding: '25px 50px',
                    height: '85vh',
                    overflow: 'auto'
                  }
                }
              }
            }
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiInputLabel-sizeSmall': {
            fontSize: '14px',
            lineHeight: '22px'
          },
          '.MuiInputBase-root': {
            '&.MuiInputBase-sizeSmall': {
              '& .MuiAutocomplete-endAdornment .MuiIconButton-root': {
                backgroundColor: '#e6efff',
                borderRadius: '5px',
                padding: '2px',
                '&.MuiAutocomplete-clearIndicator': {
                  marginRight: '5px !important'
                  // '.MuiSvgIcon-root': {
                  //   fontSize: '1.5rem'
                  // }
                },
                '&.Mui-disabled': {
                  backgroundColor: '#e6efff',
                  color: '#1640d6'
                },
                '&:hover': {
                  borderColor: '#e6efff',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                },
                '& .MuiSvgIcon-root': {
                  color: '#1640d6'
                }
              }
            },
            '& .MuiAutocomplete-endAdornment .MuiIconButton-root': {
              backgroundColor: '#e6efff',
              borderRadius: '5px',
              padding: '8px',
              '&.Mui-disabled': {
                display: 'none'
              },
              '&.MuiAutocomplete-clearIndicator': {
                marginRight: '5px !important'
                // '.MuiSvgIcon-root': {
                //   fontSize: '1.5rem'
                // }
              },
              '&:hover': {
                borderColor: '#e6efff',
                borderWidth: '1px',
                borderStyle: 'solid'
              },
              '& .MuiSvgIcon-root': {
                color: '#1640d6'
              }
            }
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        // Name of the slot
        root: {
          '&.MuiTextField-root': {
            '.MuiInputLabel-sizeSmall': {
              fontSize: '14px',
              lineHeight: '22px'
            },
            '.MuiInputBase-sizeSmall': {
              '.MuiInputAdornment-root': {
                '.MuiIconButton-root': {
                  backgroundColor: '#e6efff',
                  borderRadius: '5px',
                  padding: '2px',
                  '&.Mui-disabled': {
                    backgroundColor: '#e6efff',
                    color: '#1640d6'
                  },
                  '&:hover': {
                    borderColor: '#e6efff',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  },
                  '.MuiSvgIcon-root': {
                    color: '#1640d6'
                  }
                }
              },
              '.MuiSelect-icon': {
                padding: '2px',
                width: '28px',
                height: '28px',
                top: '6px'
              }
            },
            '.MuiSelect-icon': {
              color: '#1640d6',
              backgroundColor: '#e6efff',
              borderRadius: '5px',
              padding: '8px',
              width: '40px',
              height: '40px',
              top: '8px'
            }
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderRadius: '5px',
            boxShadow: 'none',
            // boxShadow: '0px 7px 18px 0px rgba(0, 1, 1, 0.1)',
            // filter: drop - shadow(0px 7px 9px rgba(0, 1, 1, 0.1));
            // border: '1px solid rgba(44,58,73,0.11)'
            border: '1px solid rgba(142,142,147,0.3)'
          },
          '.MuiInputAdornment-root': {
            '.MuiIconButton-root': {
              backgroundColor: '#e6efff',
              borderRadius: '5px',
              padding: '8px',
              '&.Mui-disabled': {
                backgroundColor: '#e6efff',
                color: '#1640d6'
              },
              '&:hover': {
                borderColor: '#e6efff',
                borderWidth: '1px',
                borderStyle: 'solid'
              },
              '.MuiSvgIcon-root': {
                color: '#1640d6'
              }
            }
          }
        }
      }
    },

    MuiDatePicker: {
      styleOverrides: {
        root: {
          backgroundColor: 'red'
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          background: '#fff',
          '.MuiTabs-flexContainer': {
            justifyContent: 'space-evenly'
          },
          '.MuiTab-root': {
            // width: '50%',
            // flex: '0 0 50%',
            // maxWidth: 'none'
          },
          '&.threeTabsWrap': {
            '.MuiTab-root': {
              width: '33.33%',
              flex: '0 0 33.33%',
              maxWidth: 'none',
              fontWeight: 700
            }
          },
          '&.fourTabsWrap': {
            '.MuiTab-root': {
              width: '25%',
              flex: '0 0 25%',
              maxWidth: 'none',
              fontWeight: 700
            }
          }
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        // Name of the slot
        root: {
          padding: '30px 0'
        }
      }
    }
  }
});
export default GlobalStyles;
